import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { FormBaseControlService } from '../form-base-control.service';
import { DynamicFormArrayStructure, DynamicDataInput } from '../dynamic-form-base';
import { FileUpload } from '../../file-upload/file-upload.component';
import { SweetAlertDirective } from '../../sweet-alert.directive';

@Component({
	selector: 'app-d-form-array',
	templateUrl: './d-form-array.component.html',
	styleUrls: ['./d-form-array.component.css']
})
export class DFormArrayComponent implements OnInit, OnChanges, AfterViewInit {
	@ViewChild(SweetAlertDirective) appSweetAlert: SweetAlertDirective;
	@Input() formElements: DynamicFormArrayStructure;
	@Input() serverInput: DynamicDataInput;
	@Input() preload: any;
	@Output() getServerInput = new EventEmitter<{ key: string, elementIndex: number, arrayIndex: number, controlledByValue?: any }>();
	@Output() valueChange = new EventEmitter<{
		key: string, elementIndex: number, arrayIndex: number, value: any, data: {},
		formInvalid: boolean, form: FormGroup
	}>();

	form: FormGroup;
	fieldInput: Array<{}> = [];
	fieldInputOptions: any[] = [];
	checkboxError: {status: boolean, controlName: string}[] = [];
	addMoreElementInvalid = false;
	documentUpload: Array<FileUpload[]> = [];
	dateObject: Array<{
		date: any, placeholder: any, format: string,
		required: boolean, readonly: boolean, message: string, key: string
	}[]> = [];
	toReturn = false;


	constructor(
		private formBuilder: FormBuilder,
		private formBaseControlService: FormBaseControlService
	) {
		this.form = formBuilder.group({});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.formElements && changes.formElements.currentValue) {
			this.form = this.formBuilder.group({
				[this.formElements.formArrayName]: this.formBuilder.array([])
			});
			/**
			 * Loop for adding formgroup to formarray
			 * Based on array length
			 */
			for (let index = 0; index < this.formElements.length; index++) {
				this.fieldInput.push({});
				this.documentUpload[index] = [];
				this.dateObject[index] = [];
				/**
				 * Loop elements to get server data
				 * Based on number of elements
				 */
				for (let eleIndex = 0; eleIndex < this.formElements.elements.length; eleIndex++) {
					if (this.formElements.elements[eleIndex].control.field.dataFromServer) {
						this.getServerInput.emit({
							key: this.formElements.elements[eleIndex].key, arrayIndex: index, elementIndex: eleIndex,
							controlledByValue: this.formElements.dataToPatch ?
								this.formElements.dataToPatch[this.formElements.formArrayName][index] : undefined
						});
					} else {
						this.fieldInput[index][this.formElements.elements[eleIndex].key] = this.formElements.elements[eleIndex].control.field.dataOptions;
					}
					/**
					 * File upload
					 */
					if (this.formElements.elements[eleIndex].control.field.controlType === 'file') {
						this.documentUpload[index][eleIndex] = {
							type: this.formElements.elements[eleIndex].control.field.file.mapTo.types,
							placeholder: this.formElements.elements[eleIndex].control.field.file.mapTo.placeholder,
							required: true,
							size: this.formElements.elements[eleIndex].control.field.file.mapTo.size,
							defaultMessage: ''
						}
					}

					/**
					 * Date
					 */
					if (this.formElements.elements[eleIndex].control.field.controlType === 'date') {
						this.dateObject[index][eleIndex] = {
							date: '',
							key: this.formElements.elements[eleIndex].key,
							placeholder: this.formElements.elements[eleIndex].control.field.placeholder,
							format: 'dd/MM/yyyy',
							required: this.formElements.elements[eleIndex].control.field.required,
							readonly: this.formElements.elements[eleIndex].control.field.readonly,
							message: this.formElements.elements[eleIndex].control.field.errorMessage.name ?
								this.formElements.elements[eleIndex].control.field.errorMessage.name :
								this.formElements.elements[eleIndex].control.field.errorMessage.customMessage
						}
						// console.log('control type = date', this.dateObject);

					}
				}
				this.formGroupArray.push(this.createFormGroup());
			}
			/**
			 * Patch Data
			 */
			if (this.formElements.dataToPatch) {
				for (let index = 0; index < this.formElements.dataToPatch[this.formElements.formArrayName].length; index++) {

					const group = this.form.get(this.formElements.formArrayName)['controls'][index] as FormGroup;
					group.patchValue(this.formElements.dataToPatch[this.formElements.formArrayName][index]);
					// this.addMoreElementInvalid = this.form.get(this.formElements.formArrayName)['controls']
					// [this.form.value[this.formElements.formArrayName].length - 1].invalid ? true : false;

					for (let eleIndex = 0; eleIndex < this.formElements.elements.length; eleIndex++) {
						/**
						 * Document patch
						 */
						if (this.formElements.elements[eleIndex].control.field.controlType === 'file') {
							const fileName = this.formElements.dataToPatch[this.formElements.formArrayName][index][
								this.formElements.elements[eleIndex].control.field.file.mapTo.controls[0].key
							];
							const name = fileName.substr(fileName.lastIndexOf('_') + 1);
							this.documentUpload[index][eleIndex] = {
								defaultMessage: '',
								placeholder: (name.length > 20) ? `${name.substring(0, 20)}...` : name,
								required: this.documentUpload[index][eleIndex].required,
								size: this.documentUpload[index][eleIndex].size,
								type: this.documentUpload[index][eleIndex].type
							}
						}

						/**
						 * Checkbox
						 */
						if (this.formElements.elements[eleIndex].control.field.controlType === 'checkbox'){

							/*let count = 0;
							if (this.formElements.elements[index].control.field.dataOptions){
								this.formElements.elements[index].control.field.dataOptions.filter(x => {
									if (x.value){
										count = count + 1;
									}
								});
								if (count !== this.formElements.elements[index].control.field.atleastRequired){
									this.addMoreElementInvalid = true;
								}
							}*/
							this.toReturn = false;
							// Bhagya changes start
							const check =
							Object.values(this.form.value[this.formElements.formArrayName][index][this.formElements.elements[eleIndex].key]);
							const indx = check.findIndex(x => x === true);
							if (indx !== -1) {
								this.checkboxError[index] = {
									status: false,
									controlName: this.formElements.elements[eleIndex].key
								};
								this.addMoreElementInvalid = false;
							}else if (this.formElements.elements[eleIndex].control.field.atleastRequired !== 0){
								this.addMoreElementInvalid = true;
							}else {
								this.addMoreElementInvalid = false;
							}
							// end
					}
						/**
						 * Date patch
						 */
						if (this.formElements.elements[eleIndex].control.field.controlType === 'date') {
							const temp = new Date(this.formElements.dataToPatch[this.formElements.formArrayName][index]
							[this.formElements.elements[eleIndex].key]);

							this.dateObject[index][eleIndex] = {
								date: temp,
								format: 'dd/MM/YYYY',
								key: this.formElements.elements[eleIndex].key,
								message: this.formElements.elements[eleIndex].control.field.errorMessage.name ?
									this.formElements.elements[eleIndex].control.field.errorMessage.name :
									this.formElements.elements[eleIndex].control.field.errorMessage.customMessage,
								placeholder: this.formElements.elements[eleIndex].control.field.placeholder,
								readonly: this.formElements.elements[eleIndex].control.field.readonly,
								required: this.formElements.elements[eleIndex].control.field.required
							};
							// console.log('date object', this.dateObject);
						}
						this.valueChange.emit(
							{
								key: this.formElements.elements[eleIndex].key,
								arrayIndex: index,
								data: this.formElements.dataToPatch,
								elementIndex: eleIndex,
								value: this.formElements.dataToPatch[this.formElements.formArrayName][index]
								[this.formElements.elements[eleIndex].key],
								formInvalid: this.getFormValidation() ,
								form: this.form
							}
						)
					}
				}
			}
			console.log('form created', this.form);
		}

		/**
		 * On Server Input
		 */
		if (changes.serverInput && changes.serverInput.currentValue) {
			this.fieldInput[this.serverInput.arrayIndex][this.serverInput.key] = this.serverInput.data;

			if (this.serverInput.fields) {
				this.serverInput.fields.filter(x => {
					this.fieldInputOptions[x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex] = {
						key: x.key, value: x.value,
						disabled: x.disabled, enabled: x.enable, readonly: x.readonly, hide: x.hide, eleIndex: x.eleIndex
					};

					if (x.value) {
						this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
							.get(x.key).setValue(x.value);
					}
					if (x.disabled) {
						this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
							.get(x.key).disable();
					}
					if (x.enable) {
						this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
							.get(x.key).enable();
					}
					if (x.clearValue) {
						if (x.clearValue.type === 'boolean') {
							this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
								.get(x.key).setValue(false);
						} else if (x.clearValue.type === 'number') {
							this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
								.get(x.key).setValue(null);
						} else {
							this.form.get(this.formElements.formArrayName)['controls'][x.arrayIndex ? x.arrayIndex : this.serverInput.arrayIndex]
								.get(x.key).setValue('');
						}
					}
				})
			}
		}
	}

	getFormValidation(){
		console.log(this.form.invalid, this.addMoreElementInvalid);
		if (this.form.invalid){
			return true;
		}else if (this.addMoreElementInvalid){
			return true;
		}else if (this.form.invalid && this.addMoreElementInvalid){
			return true;
		} else {
			return false;
		}
	}

	ngOnInit() { }

	ngAfterViewInit() {
		this.getAddMoreElementValidation();
	}

	get formGroupArray() {
		return this.form.get([this.formElements.formArrayName]) as FormArray;
	}

	createFormGroup(): FormGroup {
		return this.formBaseControlService.toFormGroup(this.formElements.elements);
	}

	getDropDownArray(arrayIndex: number, key: string): Array<{}> {
		let arr: any[] = [];
		if (Array.isArray(this.fieldInput[arrayIndex][key])) {
			arr = this.fieldInput[arrayIndex][key];
			return arr;
		}
	}

	// onKeyDown(event, arrayIndex, elementIndex, key) {
	// 	if ((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 8) {
	// 		this.onNumberDataChange(arrayIndex, elementIndex, key);
	// 		return true;
	// 	} else {
	// 		event.stopPropagation();
	// 		event.preventDefault();
	// 		event.returnValue = false;
	// 		event.cancelBubble = true;
	// 		return false;
	// 	}
	// }

	onNumberDataChange(event, key: string, arrayIndex, elementIndex) {
		// console.log(event.keyCode);
		for (let index = 0; index < this.form.value[this.formElements.formArrayName].length; index++) {
			if (this.form.value[this.formElements.formArrayName][index][key] !== ''
				&& this.form.value[this.formElements.formArrayName][index][key] !== null) {
				let isString = false;
				for (let charIndex = 0; charIndex < this.form.value[this.formElements.formArrayName][index][key].length; charIndex++) {
					const str = this.form.value[this.formElements.formArrayName][index][key];
					const d = str.charCodeAt(charIndex);
					if (d < 48 || d > 57) {
						isString = true;
						break;
					}
				}
				if (!isString) {
					this.form.get(this.formElements.formArrayName)['controls'][index].get(key).setValue(
						Number(this.form.value[this.formElements.formArrayName][index][key]));
					this.onDataChange(arrayIndex, elementIndex);
				}
			} else {
				this.form.get(this.formElements.formArrayName)['controls'][index].get(key).setValue(null);
			}
		}
	}

	checkedCount(arrayIndex: number, elementIndex: number): boolean {
		let toReturn = false;
		if (this.formElements.elements[elementIndex].control.field.controlType === 'checkbox') {
			const dataOptions = this.formElements.elements[elementIndex].control.field.dataOptions;
			if (this.formElements.elements[elementIndex].control.field.atleastRequired) {
				const idx = dataOptions.findIndex(x => x.value === true);
				if (idx === -1) {
					toReturn = true;
				}
			} else {
				for (let index = 0; index < dataOptions.length; index++) {
					if (dataOptions[index].required && dataOptions[index].value === false) {
						toReturn = true;
						break;
					}
				}
				console.log('toReturn', toReturn);
				return toReturn;
			}
		}
	}

	onDataChange(arrayIndex, elementIndex, checkbox?: boolean, count?: number, event?: any) {
		if (checkbox) {
			this.toReturn = true;
			this.formElements.elements[elementIndex].control.field.dataOptions[count].value = event.target.checked;
			const check = Object.values(this.form.value[this.formElements.formArrayName][arrayIndex][this.formElements.elements[elementIndex].key]);
			const indx = check.findIndex(x => x === true);
			if (indx !== -1) {
				console.log('on data ch');
				this.checkboxError[arrayIndex] = {
					status: false,
					controlName: this.formElements.elements[elementIndex].key
				}
				// console.log(this.checkboxError[arrayIndex], 'AAAAAAAAAAAAAAAAAAAAAAA');
				this.addMoreElementInvalid = false;
				this.valueChange.emit({
					key: this.formElements.elements[elementIndex].key, elementIndex: elementIndex,
					arrayIndex: arrayIndex,
					value: this.form.value[this.formElements.formArrayName][arrayIndex][this.formElements.elements[elementIndex].key],
					data: this.form.getRawValue(),
					formInvalid: this.getFormValidation(),
					form: this.form
				});
			} else if (this.formElements.elements[elementIndex].control.field.atleastRequired !== 0) {
				this.checkboxError[arrayIndex] = {
					status: true,
					controlName: this.formElements.elements[elementIndex].key
				};
				this.addMoreElementInvalid = true;
				this.valueChange.emit({
					key: this.formElements.elements[elementIndex].key, elementIndex: elementIndex,
					arrayIndex: arrayIndex,
					value: this.form.value[this.formElements.formArrayName][arrayIndex][this.formElements.elements[elementIndex].key],
					data: this.form.getRawValue(),
					formInvalid: true,
					form: this.form
				});
			} else {
				this.addMoreElementInvalid = false;
				this.valueChange.emit({
					key: this.formElements.elements[elementIndex].key, elementIndex: elementIndex,
					arrayIndex: arrayIndex,
					value: this.form.value[this.formElements.formArrayName][arrayIndex][this.formElements.elements[elementIndex].key],
					data: this.form.getRawValue(),
					formInvalid: this.getFormValidation(),
					form: this.form
				});
			}
		} else {
			if (this.formElements.elements[elementIndex].control.field.controlling) {
				const controlIndex = this.formElements.elements.findIndex(x => x.key ===
					this.formElements.elements[elementIndex].control.field.controlling);
				if (controlIndex !== -1) {
					this.form.get(this.formElements.formArrayName)['controls'][arrayIndex].get(
						this.formElements.elements[controlIndex].key
					).setValue('');
				}
			}
			if (this.formElements.elements[elementIndex].control.field.mapTo) {
				const keyIndex = this.fieldInput[arrayIndex][this.formElements.elements[elementIndex].key]
					.findIndex(x =>
						x[this.formElements.elements[elementIndex].control.field.optionValue] ===
						this.form.value[this.formElements.formArrayName][arrayIndex]
						[this.formElements.elements[elementIndex].key]
					);
				if (keyIndex !== -1) {
					this.form.get(this.formElements.formArrayName)['controls'][arrayIndex]
						.get(this.formElements.elements[elementIndex].control.field.mapTo.controlKey)
						.setValue(
							this.fieldInput[arrayIndex][this.formElements.elements[elementIndex].key][keyIndex]
							[this.formElements.elements[elementIndex].control.field.mapTo.valueKey]
						)
				}
			}
			this.valueChange.emit({
				key: this.formElements.elements[elementIndex].key, elementIndex: elementIndex,
				arrayIndex: arrayIndex,
				value: this.form.value[this.formElements.formArrayName][arrayIndex][this.formElements.elements[elementIndex].key],
				data: this.form.getRawValue(),
				formInvalid: this.getFormValidation(),
				form: this.form
			});
		}
	}

	/**
	 * Remove element form array
	 */
	removeElement(index: number) {
		this.fieldInput.splice(index, 1);
		this.formGroupArray.removeAt(index);
		this.valueChange.emit({
			arrayIndex: -1,
			data: this.form.value,
			elementIndex: -1,
			key: '',
			value: '',
			formInvalid: this.getFormValidation(),
			form: this.form
		});
		if (this.documentUpload[index]) {
			this.documentUpload.splice(index, 1)
		}
		if (this.dateObject[index]) {
			this.dateObject.splice(index, 1)
		}
		// if (this.checkboxError[index]) {
		// 	this.checkboxError.splice(index, 1);
		// }
	}

	/**
	 * Add element from array
	 */
	addElement() {
		this.fieldInput.push({});
		this.dateObject[this.form.value[this.formElements.formArrayName].length] = [];
		/**
		 * Loop elements to get server data
		 * Based on number of elements
		 */
		for (let eleIndex = 0; eleIndex < this.formElements.elements.length; eleIndex++) {
			if (this.formElements.elements[eleIndex].control.field.dataFromServer) {
				this.getServerInput.emit({
					key: this.formElements.elements[eleIndex].key,
					arrayIndex: this.form.value[this.formElements.formArrayName].length, elementIndex: eleIndex
				});
			} else {
				this.fieldInput[this.form.value[this.formElements.formArrayName].length][this.formElements.elements[eleIndex].key] =
					this.formElements.elements[eleIndex].control.field.dataOptions;
			}
			/**
			 * Add Document
			 */
			if (this.formElements.elements[eleIndex].control.field.controlType === 'file') {
				this.documentUpload[this.form.value[this.formElements.formArrayName].length] = [];
				this.documentUpload[this.form.value[this.formElements.formArrayName].length][eleIndex] = {
					defaultMessage: '',
					placeholder: this.formElements.elements[eleIndex].control.field.file.mapTo.placeholder,
					required: this.formElements.elements[eleIndex].control.field.required,
					size: this.formElements.elements[eleIndex].control.field.file.mapTo.size,
					type: this.formElements.elements[eleIndex].control.field.file.mapTo.types
				}
			}
			/**
			 * Add Date
			 */
			if (this.formElements.elements[eleIndex].control.field.controlType === 'date') {
				this.dateObject[this.form.value[this.formElements.formArrayName].length][eleIndex] = {
					date: '',
					key: this.formElements.elements[eleIndex].key,
					placeholder: this.formElements.elements[eleIndex].control.field.placeholder,
					required: this.formElements.elements[eleIndex].control.field.required,
					format: 'dd/MM/YYYY',
					message: this.formElements.elements[eleIndex].control.field.errorMessage.name ?
						this.formElements.elements[eleIndex].control.field.errorMessage.name :
						this.formElements.elements[eleIndex].control.field.errorMessage.customMessage,
					readonly: this.formElements.elements[eleIndex].control.field.readonly
				};
			}
		}
		this.formGroupArray.push(this.createFormGroup());
		this.getAddMoreElementValidation();
	}

	/**
	 * Form CSS
	 */
	getLabelClass(width: number): string {
		return `col-lg-${width} col-form-label`
	}

	getFieldClass(width: number): string {
		return `col-lg-${width}`
	}

	/**
	 * Add more element
	 * @Validation
	 */
	getAddMoreElementValidation() {
		const checkboxIndex = this.formElements.elements.findIndex(x => x.control.field.controlType === 'checkbox');
		if (checkboxIndex !== -1) {
			if (this.formElements.elements[checkboxIndex].control.field.atleastRequired &&
				this.formElements.elements[checkboxIndex].control.field.atleastRequired !== 0) {
					let count = 0;
					this.formElements.elements[checkboxIndex].control.field.dataOptions.filter(x => {
						if (x.value){
							count = count + 1;
						}
					});
					if (count !== this.formElements.elements[checkboxIndex].control.field.atleastRequired){
						this.addMoreElementInvalid = true;
					}
				// this.addMoreElementInvalid = this.form.get(this.formElements.formArrayName)['controls']
				// [this.form.value[this.formElements.formArrayName].length - 1].invalid ? true : false;
			}
		}
	}

	/**
	 * Document Upload
	 */
	onFileUploaded(event, arrayIndex, elementIndex) {
		if (event.url) {
			this.form.get(this.formElements.formArrayName)['controls'][arrayIndex].get(
				this.formElements.elements[elementIndex].control.field.file.mapTo.controls[0].key
			).setValue(event.url);
			this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} uploaded successfully!!!` })
		}
	}

	onFileUploadCancel(event, arrayIndex, elementIndex) {
		console.log(this.formElements.elements);

		if (event === true) {
			this.form.get(this.formElements.formArrayName)['controls'][arrayIndex].get(
				this.formElements.elements[elementIndex].control.field.file.mapTo.controls[0].key
			).setValue('');
		}
	}

	/**
	 * Date Change Event
	 */
	onDateChange(event, arrayIndex, elementIndex) {
		if (String(event) !== 'Invalid Date') {
			// const idx = this.dateObject[arrayIndex].findIndex(x => x.key === element.key);
			// this.dateObject[arrayIndex][idx].date = event;
			this.form.get(this.formElements.formArrayName)['controls'][arrayIndex].get(this.formElements.elements[elementIndex].key)
				.setValue(event.toISOString());
		}
	}

	/**
	 * Get Remove/Add more button style
	 */
	getClass(type: string): string {
		if (this.formElements.smallScreen) {
			if (type === 'div') {
				return 'col-lg-7';
			} else if (type === 'remove') {
				return 'col-lg-2';
			} else if (type === 'add') {
				return 'col-lg-1';
			}
		} else {
			if (type === 'div') {
				return 'col-lg-9';
			} else if (type === 'remove') {
				return 'col-lg-1';
			} else if (type === 'add') {
				return 'col-lg-1';
			}
		}
	}

	isCheckboxHidden(dataElement, cIdx, aIdx){
		if (dataElement.arrayIndex !== undefined && dataElement.checkIndex !== undefined){
			if (dataElement.hide){
				const arrIdx = dataElement.arrayIndex.findIndex(x => x === aIdx);
				if (arrIdx !== -1){
					const idx = dataElement.checkIndex.findIndex(y => y === cIdx);
					if (idx !== -1){
						return true;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

}
